// extracted by mini-css-extract-plugin
module.exports = {"rank":"style_rank__1K9fQ","item":"style_item__3px9a","title":"style_title__3DuoX","author":"style_author__1SHK4"};